import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const FeaturedArticles = ({ articles }) => {
  if (!articles || articles.length === 0) return null;

  const mainFeatured = articles[0];
  const secondaryFeatured = articles.slice(1, 3);

  return (
    <section className="mb-12">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-3xl font-heading font-bold text-text-primary">
          Artículos Destacados
        </h2>
        <div className="flex items-center space-x-2 text-accent">
          <Icon name="Star" size={20} />
          <span className="text-sm font-medium">Recomendados por expertos</span>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Main Featured Article */}
        <div className="lg:col-span-2">
          <article className="bg-surface rounded-lg border border-border overflow-hidden shadow-medium hover:shadow-large nav-transition group">
            <div className="relative overflow-hidden h-64 lg:h-80">
              <Image
                src={mainFeatured.image}
                alt={mainFeatured.title}
                className="w-full h-full object-cover group-hover:scale-105 nav-transition"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-accent text-white px-3 py-1 rounded-full text-xs font-medium">
                  Destacado
                </span>
              </div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="bg-black/70 backdrop-blur-sm rounded-lg p-4 text-white">
                  <div className="flex items-center space-x-4 text-sm mb-2">
                    <div className="flex items-center space-x-1">
                      <Icon name="Calendar" size={14} />
                      <span>{new Date(mainFeatured.publishDate).toLocaleDateString('es-CR')}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Icon name="Clock" size={14} />
                      <span>{mainFeatured.readTime}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Icon name="User" size={14} />
                      <span>{mainFeatured.author}</span>
                    </div>
                  </div>
                  <h3 className="text-xl font-heading font-semibold mb-2 line-clamp-2">
                    {mainFeatured.title}
                  </h3>
                  <p className="text-gray-200 text-sm line-clamp-2">
                    {mainFeatured.excerpt}
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6">
              <div className="flex flex-wrap gap-2 mb-4">
                {mainFeatured.tags.map((tag, index) => (
                  <span
                    key={index}
                    className="bg-primary/10 text-primary px-2 py-1 rounded-md text-xs font-medium"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
              <Link
                to={`/blog-resources/${mainFeatured.id}`}
                className="inline-flex items-center space-x-2 text-primary font-medium hover:text-primary/80 nav-transition"
              >
                <span>Leer artículo completo</span>
                <Icon name="ArrowRight" size={16} />
              </Link>
            </div>
          </article>
        </div>

        {/* Secondary Featured Articles */}
        <div className="space-y-6">
          {secondaryFeatured.map((article) => (
            <article
              key={article.id}
              className="bg-surface rounded-lg border border-border overflow-hidden shadow-medium hover:shadow-large nav-transition group"
            >
              <div className="relative overflow-hidden h-48">
                <Image
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 nav-transition"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary text-white px-2 py-1 rounded-full text-xs font-medium">
                    Destacado
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center space-x-3 text-xs text-text-secondary mb-2">
                  <div className="flex items-center space-x-1">
                    <Icon name="Calendar" size={12} />
                    <span>{new Date(article.publishDate).toLocaleDateString('es-CR')}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Icon name="Clock" size={12} />
                    <span>{article.readTime}</span>
                  </div>
                </div>
                <h3 className="text-lg font-heading font-semibold text-text-primary mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-text-secondary text-sm line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap gap-1 mb-3">
                  {article.tags.slice(0, 2).map((tag, index) => (
                    <span
                      key={index}
                      className="bg-secondary/10 text-secondary px-2 py-1 rounded-md text-xs"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
                <Link
                  to={`/blog-resources/${article.id}`}
                  className="inline-flex items-center space-x-1 text-primary text-sm font-medium hover:text-primary/80 nav-transition"
                >
                  <span>Leer más</span>
                  <Icon name="ArrowRight" size={14} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedArticles;